import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  compose,
  lifecycle,
  withProps,
  branch,
  renderComponent,
} from 'recompose'
import { fetchProductElement } from './productActions'
import { makeSelectSingleProduct } from '../elementSelectors'

export default () => compose(
  connect(
    () => {
      const selectProducts = makeSelectSingleProduct()

      return (state, props) => selectProducts(state, props)
    },
    (dispatch) => bindActionCreators({ fetchProductElement }, dispatch),
  ),
  withProps(({ defaultContent }) => ({ sku: defaultContent.sku })),
  lifecycle({
    componentDidMount() {
      const {
        fetchProductElement,
        product,
        sku,
        api,
      } = this.props
      if (!product && sku) {
        // fetch when no product and sku is not empty
        fetchProductElement(api, sku)
      }
    },
    componentWillReceiveProps(nextProps) {
      const {
        fetchProductElement,
        sku,
        api,
        product,
      } = nextProps
      if (this.props.sku !== sku && sku && !product) {
        fetchProductElement(api, sku)
      }
    },
  }),
  branch(
    ({ product, fetchStatus }) => (!product && fetchStatus.isInitial) || fetchStatus.isFailure,
    renderComponent(
      ({ renderElement }) => renderElement(
        () => (
          <img
            alt={''}
            src="https://s3-ap-southeast-1.amazonaws.com/cms.alpha.incart/assets/NO-product.png"
            style={{
              maxWidth: '100%',
              display: 'inline-block',
            }}
          />
        ),
      ),
    ),
  ),
)



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/redux/product/withProductElement.js